<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>培训总览</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="overview-cards">
            <div class="cards-top">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>任务总数</span>
                    </div>
                    <div id="myChart" :style="{ width: '100%', height: '100%' }"></div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>课程总数</span>
                    </div>
                    <div id="coursesNumberChart" :style="{ width: '100%', height: '100%' }"></div>

                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>题目总数</span>
                    </div>
                    <div id="questionsNumberChart" :style="{ width: '100%', height: '100%' }"></div>

                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>试卷总数</span>
                    </div>
                    <div id="papersNumberChart" :style="{ width: '100%', height: '100%' }"></div>
                </el-card>
            </div>
            <div class="cards-bottom">
                <el-card class="box-card">
                    <div class="d-flex flex-justify-between flex-align-center" style="width: 100%;">
                        <!-- 搜索筛选 -->
                        <el-form :inline="true" size="small" :model="formInline" class="user-search">
                            <el-form-item>
                                <el-date-picker v-model="formInline.date" type="datetimerange" size="small"
                                    :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                        <el-button type="primary" size="small" @click="getExamStatPage()">搜索</el-button>
                    </div>
                    <div id="examinationPassChart" :style="{ width: '100%', height: '520px' }"></div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>培训任务</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="showMore()">查看更多</el-button>
                    </div>
                    <div class="overview-content">
                        <div class="d-flex flex-justify-between flex-align-center" style="width: 100%;">
                            <!-- 搜索筛选 -->
                            <el-form :inline="true" size="small" :model="formInline" class="user-search">
                                <el-form-item>
                                    <el-input v-model="formInline.planName" placeholder="请输入任务名称"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-button type="primary" size="small" @click="getTableData()">搜索</el-button>
                        </div>
                        <my-table :columns="tableForm.customColumns" :tableConfig="tableForm.tableConfig"
                            :tableData="tableForm.tableData" :loading="tableForm.isLoading">
                            <el-table-column align="center" prop="userSex" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="goTraingList(scope.row)"
                                        v-buttonAuth="'system:onlineTraing:list'">查看</el-button>
                                </template>
                            </el-table-column>
                        </my-table>
                    </div>


                </el-card>
            </div>
        </div>
        <el-dialog title="培训任务" :visible.sync="dialogVizible" :close-on-click-modal="false" v-loading="true"
            custom-class="form-dialog" width="70%" @close='closeExportDialog()'>
            <div class="overview-content">
                <div class="d-flex flex-justify-between flex-align-center" style="width: 100%;">
                    <!-- 搜索筛选 -->
                    <el-form :inline="true" size="small" :model="formInline" class="user-search">
                        <el-form-item>
                            <el-input v-model="formInline.dialogPlanName" placeholder="请输入任务名称"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-button type="primary" size="small" @click="pageparm.currentPage=1;getDialogTableData()">搜索</el-button>
                </div>
                <div style="height: 500px;">

                    <my-table :columns="tableForm.customColumns" :tableConfig="tableForm.tableConfig"
                        :tableData="dialogTableData" :loading="tableForm.isLoading">
                        <el-table-column align="center" prop="userSex" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="goTraingList(scope.row)"
                                    v-buttonAuth="'system:onlineTraing:list'">查看</el-button>
                            </template>
                        </el-table-column>
                    </my-table>
                </div>
                <div class="main-pagination">
                    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import { overviewCount, planStatisticPage } from '@/api/onlineTraining/overview.js'
import { examStatPage } from '@/api/exam.js'
import { timestampToTime } from '@/utils/util.js'
export default {
    components: {
        MyTable,
        Pagination
    },
    data () {
        return {
            formInline: {
                date: [],
                planName: '',
                dialogPlanName: '',
            },
            dialogVizible: false,
            dialogTableData: [],
            tableForm: {
                customColumns: [
                    { label: '培训任务名称', prop: 'planName' },
                    { label: '任务人数', prop: 'allCount' },
                    { label: '通过人数', prop: 'passCount' },
                    { label: '通过率', prop: 'passRate', formatter: (item) => { return item + '%' } },
                ],
                tableData: [
                    // ...其他数据
                ],
                tableConfig: {
                    noCheck: true,
                },
                isLoading: false,
                checkList: []
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },

        }
    },
    mounted () {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        this.formInline.date = [new Date(y, m, 1).getTime(), new Date().getTime()]
        this.getData();
        this.getExamStatPage();
        this.getTableData();
    },
    methods: {
        getData () {
            overviewCount().then(res => {
                this.initChart(res.data.planCount);
                this.initCoursesNumberChart(res.data.courseCount);
                this.initQuestionsNumberChart(res.data.questionCount);
                this.initPapersNumberChart(res.data.examPaperCount);
            })
        },
        prefabricatedOption (title, data) {
            const option = {
                title: {
                    text: title,
                    x: "center",
                    top: "5%",
                    textStyle: {
                        fontSize: 15,
                        fontWeight: "bold",
                        color: "#000"
                    }
                },
                color: ["#409eff"],
                series: [
                    {
                        name: "",
                        type: "pie",
                        center: ["50%", "50%"],
                        radius: ["40%", "55%"],
                        startAngle: 180,
                        silent: true,
                        label: {
                            position: "center",
                            formatter: function (params) {
                                return params.value;
                            },
                            fontWeight: "bold",
                            fontSize: 16,
                            color: '#666'
                        },
                        labelLine: {
                            show: false,
                        },
                        data: data
                    },

                ],
            };
            return option
        },
        initChart (num) {
            const chart = this.$echarts.init(document.getElementById('myChart'));
            chart.setOption(this.prefabricatedOption('发布任务总数', [
                {
                    name: "",
                    value: num
                },
            ]))
            // ...
        },
        initCoursesNumberChart (num) {
            const chart = this.$echarts.init(document.getElementById('coursesNumberChart'));
            chart.setOption(this.prefabricatedOption('发布课程总数', [
                {
                    name: "",
                    value: num
                },
            ]))
        },
        initQuestionsNumberChart (num) {
            const chart = this.$echarts.init(document.getElementById('questionsNumberChart'));
            chart.setOption(this.prefabricatedOption('题目总数', [
                {
                    name: "",
                    value: num
                },
            ]))
        },
        initPapersNumberChart (data) {
            const chart = this.$echarts.init(document.getElementById('papersNumberChart'));
            let Data = [{
                value: data.randomCount,
                name: "随机"
            },
            {
                value: data.fixedCount,
                name: "固定"
            }
            ];
            const colorList = [
                '#3698f8', '#36c1a1'
            ];
            const option = {
                title: {
                    text: '试卷总数',
                    x: "center",
                    top: "5%",
                    textStyle: {
                        fontSize: 15,
                        fontWeight: "bold",
                        color: "#000"
                    }
                },
                tooltip: {
                    trigger: "item"
                },
                legend: {
                    type: "plain",
                    orient: "vertical",
                    left: "1%",
                    top: "center",
                    align: "left",
                    itemGap: 10,
                    itemWidth: 15, // 设置宽度
                    itemHeight: 15, // 设置高度]
                    symbolKeepAspect: false,
                    selectedMode: false,
                    textStyle: {
                        color: "#333333",
                        fontSize: 12
                    }
                },
                graphic: {
                    type: "text",
                    left: "center",
                    top: "center",
                    style: {
                        text: Number(data.randomCount) + Number(data.fixedCount),
                        textAlign: "center",
                        fill: "#333",
                        fontSize: 20,
                        fontWeight: 700
                    }
                },
                series: [{
                    type: "pie",
                    hoverAnimation: true,
                    hoverOffset: 25,
                    startAngle: 180, //起始角度
                    clockwise: false, //是否顺时针
                    center: ["50%", "50%"],
                    radius: ["40%", "55%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        color: params => {
                            return colorList[params.dataIndex];
                        }
                    },
                    label: {
                        show: false,
                        position: "center",
                        color: "rgba(13, 17, 29,0)"
                    },
                    labelLine: {
                        show: false
                    },
                    data: Data,
                    zlevel: 30
                }]
            };
            chart.setOption(option)
        },
        getExamStatPage () {
            let params = {
                startPublishTime: '',
                endPublishTime: '',
                pageNum: 1,
                pageSize: 9999,
            }
            if (this.formInline.date.length) {
                params.startPublishTime = timestampToTime(this.formInline.date[0]);
                params.endPublishTime = timestampToTime(this.formInline.date[1]);
            }
            examStatPage(params).then(res => {
                this.initExaminationPassChart(res.data.records.map(el => el.examName), res.data.records.map(el => el.passRate * 100))
            })

        },
        initExaminationPassChart (xData, data) {
            const chart = this.$echarts.init(document.getElementById('examinationPassChart'));
            const option = {
                title: {
                    text: '考试合格率%',
                    x: "left",
                    textStyle: {
                        fontSize: 15,
                        fontWeight: "bold",
                        color: "#000"
                    }
                },
                grid: {
                    containLabel: true,
                    top: 35,
                    right: 15,
                    bottom: 0,
                    left: 10
                },
                tooltip: {
                    trigger: "axis",
                    formatter: function (params) {
                        var res;
                        res = `<div>${params[0].name}:${params[0].value}%</div>`
                        return res
                    },
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    // 类目轴
                    type: "category",
                    data: xData,
                    // 轴线设置
                    axisLine: {
                        show: true,
                        lineStyle: { color: "#4ba0d0", type: "solid" }
                    },
                    // 坐标轴刻度
                    axisTick: {
                        show: false
                    },
                    // 坐标轴标签
                    axisLabel: {
                        show: true,
                        fontSize: 14,
                        // interval: 0,
                        color: "#4ba0d0",
                        fontFamily: "SourceHanSansCN-Normal, SourceHanSansCN",
                        formatter: function (params) {
                            var val = "";
                            if (params.length > 3) {
                                val = params.substr(0, 3) + '...';
                                return val;
                            } else {
                                return params;
                            }
                        }
                    }
                },
                yAxis: {
                    // 最小间隔
                    minInterval: 1,
                    // 轴线设置
                    axisLine: {
                        show: true,
                        lineStyle: { color: "#4ba0d0", type: "solid" }
                    },
                    // 坐标轴刻度
                    axisTick: {
                        show: false
                    },
                    // 坐标轴标签
                    axisLabel: {
                        show: true,
                        fontSize: 14,
                        color: "#4ba0d0",
                        fontFamily: "SourceHanSansCN-Normal, SourceHanSansCN"
                    },
                    // grid区分割线
                    splitLine: {
                        show: true,
                        lineStyle: { color: "#CAE8EA30", type: "solid" }
                    }
                },
                series: [
                    {
                        type: "bar",
                        barWidth: "50%",
                        itemStyle: {
                            color: '#2e9b98'
                        },
                        data: data
                    }
                ]
            }
            chart.setOption(option)

        },

        getTableData () {
            const params = {
                planName: this.formInline.planName,
                pageSize: 7,
                pageNum: 1,
            }
            planStatisticPage(params).then(res => {
                this.tableForm.tableData = res.data.records;
            })
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getDialogTableData();
        },
        getDialogTableData () {
            const params = {
                planName: this.formInline.dialogPlanName,
                pageSize: this.pageparm.pageSize,
                pageNum: this.pageparm.currentPage,
            }
            planStatisticPage(params).then(res => {
                this.dialogTableData = res.data.records;
                this.pageparm.total = res.data.total
            })
        },
        showMore () {
            this.dialogVizible = true;
            this.getDialogTableData();
        },
        closeExportDialog () {
            this.dialogVizible = false;

        },
        goTraingList (item) {
            this.$router.push({
                path: '/onlineTraining/trainingPlan',
                query:{
                    planName:item.planName
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.clearfix {
    span {
        font-weight: 700;
        font-size: 20px;
    }
}

.overview-cards {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;

    .cards-top,
    .cards-bottom {
        flex: 1;
        padding-top: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .box-card {
            display: flex;
            flex: 1;
            flex-direction: column;
            height: 100%;
            margin-right: 20px;
        }
    }
}

.overview-content {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/views/onlineTraining/overview.vue